export default __webpack_public_path__ + "static/aerial-cff9a4042d2fd73d81d251488d74e188.mp4";